export const handleError = (error) => {

    console.log("Error", error);

};